import {
    CreateTimesheetSetup,
    EnterUserHoursInput,
    GenerateTimesheetSubmit,
    UpdateUserHoursInput
} from './timesheet.interface';

export class CreateTimesheetSetupInput {
    static readonly type = '[timesheet] create timesheet';
    constructor(public payload: CreateTimesheetSetup) {}
}

export class GetTimesheetProgram {
    static readonly type = '[timesheet] get program';
    constructor(public program: string) {}
}

export class GetTimesheetProgramId {
    static readonly type = '[timesheet] get program id';
    constructor(public input: { id: string; query: string }) {}
}

export class GetTimesheetWWU {
    static readonly type = '[timesheet] get timesheet wwu';
    constructor(public programId: string) {}
}

export class EnterUserHours {
    static readonly type = '[timesheet] enter users hours';
    constructor(public payload: EnterUserHoursInput) {}
}
export class UpdateUserHours {
    static readonly type = '[timesheet] update users hours';
    constructor(public payload: UpdateUserHoursInput) {}
}

export class SubmitTimesheet {
    static readonly type = '[timesheet] submit timesheet';
    constructor(public payload: GenerateTimesheetSubmit) {}
}
export class GetSingleTimesheetRequest {
    static readonly type = '[timesheet] get-one';
    constructor(public input: { id: string; query: string }) {}
}

export class GetTimesheetsByApprovers {
    static readonly type = '[timesheet] approvers';
    constructor(public input: { id: string; query: string }) {}
}
export class GetTimesheetByReviewer {
    static readonly type = '[timesheet] reviewer';
    constructor(public input: { id: string; query: string }) {}
}

export class GetTimesheetsByUser {
    static readonly type = '[timesheet] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
